import CurrentSummary from './current-summary';

export default CurrentSummary;
